// Mirrors FLAG_REASONS in lib/listingFlags.js
export const FLAG_REASONS = [
  ['wrong_date', 'Wrong date'],
  ['wrong_time', 'Wrong time'],
  ['wrong_type', 'Wrong type'],
  ['duplicate', 'Duplicate'],
  ['wrong_place', 'Wrong place'],
  ['wrong_info', 'Wrong name / info'],
  ['should_not_exist', 'Not a real event'],
  ['other', 'Other'],
];

export const reasonLabel = (key) => (FLAG_REASONS.find(([k]) => k === key) || [key, key])[1];
